import { Add } from '@material-ui/icons'
import ButtonBase from 'components/common/ButtonBase'
import styled from 'styled-components'
import { limitTextNumberOfLines, resetButton, respondAbove } from 'styles/mixins'
import IconComponent from 'themes/IconComponent'
import TypographyPro from 'themes/TypographyPro'

export const StyledSavedAddressesContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 1.25rem 1.25rem 0 1.25rem;
	max-height: calc(80vh - 3rem);
	width: 568px;
	max-width: 100%;

	${respondAbove.md`
    padding: 1.75rem 1.75rem 0 1.75rem;
  `}
`

export const StyledSavedAddressesTitle = styled(TypographyPro)`
	color: var(--strokeMenuTitle);
	text-transform: capitalize;
`

export const StyledSavedAddressesPlaceholderIcon = styled(IconComponent)`
	width: 5rem;
	height: 6.25rem;
	padding-bottom: 0.75rem;
`

export const StyledSavedAddressesPlaceholderText = styled(TypographyPro)`
	text-align: center;
	color: var(--inactive);
`

export const StyledSavedAddressesList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
	overflow: auto;
	padding: 0 0.25rem 0.5rem 0.25rem;
	width: 100%;
`

export const StyledSavedAddressButton = styled.button<{ selected?: boolean }>`
	${resetButton}
	width: 100%;
	display: flex;
	align-items: center;
	padding: 1rem;
	gap: 0.75rem;
	background-color: var(--bgLight);
	border-radius: var(--borderRadiusM);
	border: solid 1px;
	border-color: ${({ selected }) => (selected ? 'var(--primary)' : 'transparent')};
	box-shadow: var(--shadowSmall);

	transition: border-color 0.125s ease-in-out;
`

export const StyledSavedAddressButtonIcon = styled(IconComponent)`
	min-width: 2.5rem;
	width: 2.5rem;
	height: 2.5rem;
`

export const StyledSavedAddressTextsContainer = styled.div`
	text-align: start;
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
`

export const StyledSavedAddressTitle = styled(TypographyPro)`
	text-transform: capitalize;
`

export const StyledSavedAddressSubtitle = styled(TypographyPro)`
	${limitTextNumberOfLines(1)}
`

export const StyledSaveAddressesAddNewAddressButton = styled(ButtonBase)`
	margin: 1.75rem 0 1.25rem;
`

export const StyledPlusIcon = styled(Add)`
	padding-right: 0.5rem;
`

export const StyledManualAddressButton = styled.button`
	${resetButton}
	display: flex;
	padding: 0.5rem;
`

export const StyledManualAddressButtonText = styled(TypographyPro)`
	color: var(--primary);
	text-transform: uppercase;

	&:hover {
		color: var(--secondary);
	}
`
